import { createAuthorizationHeaderValue } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

type AuthHeader = {
  Authorization: string;
};

type CacheControlHeader = {
  'Cache-Control': 'no-cache';
  Pragma: 'no-cache';
};

export function isPrivateFilesAPI(filePath: string): boolean {
  return filePath.includes(
    `${config.url.files.replace('https://', '').replace('/', '')}/private`,
  );
}

export async function getFileHeaders(
  isPrivateFile: boolean,
): Promise<AuthHeader | CacheControlHeader> {
  return isPrivateFile
    ? {
        Authorization: await createAuthorizationHeaderValue(),
      }
    : {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      };
}
